module.exports = __webpack_public_path__ + "static/media/jp_logo.9921c9ba.jpg";